import { render, staticRenderFns } from "./deviceManagerItem.vue?vue&type=template&id=1823a614&scoped=true&"
import script from "./deviceManagerItem.vue?vue&type=script&lang=js&"
export * from "./deviceManagerItem.vue?vue&type=script&lang=js&"
import style0 from "./deviceManagerItem.vue?vue&type=style&index=0&id=1823a614&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1823a614",
  null
  
)

export default component.exports